module.exports = __webpack_public_path__ + "img/img_0.9eb5e907.png";